module.exports = __webpack_public_path__ + "static/media/nouvelr-bold.274fda0e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/nouvelr/nouvelr-bold.ttf
// module id = 938
// module chunks = 0